module.exports = __webpack_public_path__ + "img/turtle.298eff23.jpg";